import { MenuItem, SxProps, Theme } from "@mui/material";
import IotVisionSelectFiled from "components/common/IotVisionSelectField";

export interface ISelectDropdownOption<T> {
    value: T;
    label: string;
    disabled?: boolean;
}

interface IIotVisionSelectDropdownProps<T> {
    value: T;
    options: ISelectDropdownOption<T>[];
    onChange: (value: T) => void;
    displayEmpty?: boolean;
    placeholder?: string;
    disabled?: boolean;
    sx?: SxProps<Theme>;
}

const IotVisionSelectDropdown = <T,>({
    value,
    options,
    onChange,
    displayEmpty = false,
    placeholder,
    disabled,
    sx,
}: IIotVisionSelectDropdownProps<T>): JSX.Element => (
    <IotVisionSelectFiled<T>
        value={value}
        onChange={(event) => onChange(event.target.value as T)}
        displayEmpty={displayEmpty}
        disabled={disabled}
        sx={sx}
    >
        {placeholder !== undefined && (
            <MenuItem value="">
                <em>{placeholder}</em>
            </MenuItem>
        )}
        {options.map((option) => (
            <MenuItem key={String(option.value)} value={option.value as unknown as string} disabled={option.disabled}>
                {option.label}
            </MenuItem>
        ))}
    </IotVisionSelectFiled>
);

export default IotVisionSelectDropdown;
